import { useEffect as f } from "react";
const y = e => ["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(e),
  v = e => {
    const n = window.getComputedStyle(e),
      r = window.getComputedStyle(e.parentElement);
    return n.display !== "none" && r.display !== "none";
  },
  g = e => {
    const n = e == null ? void 0 : e.querySelectorAll("[data-header-keyboard-navigation], .olx-text-input__input-field");
    return n ? Array.from(n).filter(v) : [];
  },
  A = (e, n) => {
    var r;
    const o = n.findIndex(l => l === e.target);
    if (o === -1) return;
    const i = n.length,
      t = n.find(l => l.classList.contains("olx-text-input__input-field")),
      u = ((r = t == null ? void 0 : t.value) == null ? void 0 : r.length) > 0,
      a = e.target === t,
      w = (t == null ? void 0 : t.ariaExpanded) === "true",
      d = u && a || !u && w && a,
      s = l => {
        const c = (o + l + i) % i,
          p = n[c];
        e.preventDefault(), p.focus();
      };
    (e.key === "ArrowRight" && !d || e.key === "ArrowDown" && !d) && s(1), (e.key === "ArrowLeft" && !d || e.key === "ArrowUp" && !d) && s(-1);
  },
  k = _ref => {
    let {
      headerWrapperRef: e,
      openSubMenu: n
    } = _ref;
    f(() => {
      const r = o => {
        var i;
        if (!y(o.key) || n || !((i = e.current) != null && i.contains(o.target))) return;
        const t = g(e.current);
        A(o, t);
      };
      return window.addEventListener("keydown", r), () => {
        window.removeEventListener("keydown", r);
      };
    }, [e, n]);
  };
export { k as useNavigation };